import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);

export default new Router({
    mode: 'hash',
    // base: process.env.BASE_URL,
    //隐藏路由
    // mode: "abstract",
    routes: [
        {
            path: '/',name: 'Home',component: () => import("@/views/Home.vue"),
            children: [
                {path: '/',name: 'MpcPledge',component: () => import("@/views/MpcPledge.vue")},
                {path: '/mpcNode',name: 'MpcNode',component: () => import("@/views/MpcNode.vue")},
                {path: '/mpcExchange',name: 'MpcExchange',component: () => import("@/views/MpcExchange.vue")},
                {path: '/mpcMy',name: 'MpcMy',component: () => import("@/views/MpcMy.vue")},
            ]
        },
        {
            path: '/admin',name: 'Home',component: () => import("@/views/AdminHome.vue"),
            children: [
                {path: '/',name: 'AdminCore',component: () => import("@/views/AdminCore.vue")},
            ]
        },
        {path: "*",redirect: "/"}
    ]
})